import React, { useState, useEffect } from 'react';
import { feesAPI } from '../../services/api';
import DataTable from '../../components/common/DataTable';
import SearchBar from '../../components/common/SearchBar';
import StatusBadge from '../../components/common/StatusBadge';
import Modal from '../../components/common/Modal';
import Pagination from '../../components/common/Pagination';
import StatCard from '../../components/common/StatCard';
import toast from 'react-hot-toast';
import { formatCurrency, formatDate } from '../../utils/helpers';
import FeeSettings from './FeeSettings';
import FeeType from './FeeType';
import FeesStrucutre from './FeesStrucutre';
import UpdateStudentFee from './UpdateStudentFee';
import CollectFee from './CollectFee';
import FeeDiscount from './FeeDiscount';

const FeeManagement = () => {
  const [tab, setTab] = useState('collections');
  const [collections, setCollections] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [summary, setSummary] = useState({});
  const [showModal, setShowModal] = useState(false);

  const [view, setView] = useState('list');

  const fetchCollections = async () => {
    setLoading(true);
    try {
      const params = { page, page_size: 15, search };
      if (statusFilter) params.status = statusFilter;
      const res = await feesAPI.collections(params);
      setCollections(res.data.results || res.data);
      setCount(res.data.count || 0);
    } catch { toast.error('Failed to load fees'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchCollections(); }, [page, search, statusFilter]);
  useEffect(() => {
    feesAPI.summary().then(r => setSummary(r.data)).catch(() => { });
  }, []);

  const columns = [
    { key: 'receipt_number', label: 'Receipt #', render: v => <code style={{ fontSize: 12 }}>{v}</code> },
    { key: 'student_name', label: 'Student', render: (v, row) => <div><strong>{v}</strong><br /><small className="text-muted">{row.admission_number}</small></div> },
    { key: 'fee_category', label: 'Fee Type' },
    { key: 'amount_due', label: 'Amount Due', render: v => formatCurrency(v) },
    { key: 'amount_paid', label: 'Amount Paid', render: v => <span style={{ color: '#10b981', fontWeight: 600 }}>{formatCurrency(v)}</span> },
    { key: 'due_date', label: 'Due Date', render: v => formatDate(v) },
    { key: 'status', label: 'Status', render: v => <StatusBadge status={v} /> },
    { key: 'payment_mode', label: 'Mode', render: v => v ? <span className="badge bg-light text-dark">{v}</span> : '—' },
  ];

  return (
    <>


      <div>
        <div className="d-flex gap-2 mb-4">
          {[
            ['list', <>
              <i className="lni lni-graduation-cap-1 fs-4 lh-0"></i>
              Fee Dashboard
            </>],

            ['FeesSettings', <>
              <i className="bi bi-patch-exclamation fs-5 lh-0"></i>
              Fees Settings
            </>],
            
             ['FeesType', <>
              <i className="lni lni-refresh-user-1 fs-4 lh-0"></i>
             Fees Type
            </>],

            ['FeesStrucutre', <>
              <i className="lni lni-refresh-user-1 fs-4 lh-0"></i>
              Fees Strucutre
            </>],

            // ['FeesDiscounts', <>
            //   <i className="lni lni-refresh-user-1 fs-4 lh-0"></i>
            //   Fees Discounts
            // </>],
            

              ['UpdateStudentFee', <>
              <i className="lni lni-refresh-user-1 fs-4 lh-0"></i>
              Update Student Fee
            </>],

            ['CollectFee', <>
              <i className="lni lni-refresh-user-1 fs-4 lh-0"></i>
              Collect Fee
            </>],

            // ['Reports', <>
            //   <i className="lni lni-refresh-user-1 fs-4 lh-0"></i>
            //   Reports
            // </>]

          ].map(([k, l]) => (
            <button
              key={k}
              className={`btn ${view === k ? 'btn-primary page-btn' : 'btn-outline-secondary page-btn'}`}
              onClick={() => setView(k)}
            >
              {l}
            </button>
          ))}
        </div>
        {view === 'list' && (
          <div>
            <div className="page-header">
              <div><h2>Fee Management</h2><p>Collection, structures, and pending dues</p></div>
              <button className="btn btn-primary" onClick={() => setShowModal(true)}>💳 Collect Fee</button>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-6 col-lg-3"><StatCard icon="💰" label="Total Collected" value={formatCurrency(summary.total_collected || 0)} color="green" /></div>
              <div className="col-6 col-lg-3"><StatCard icon="📋" label="Total Due" value={formatCurrency(summary.total_due || 0)} color="blue" /></div>
              <div className="col-6 col-lg-3"><StatCard icon="⚠️" label="Pending Count" value={summary.pending_count || 0} color="orange" /></div>
              <div className="col-6 col-lg-3"><StatCard icon="📈" label="Collection Rate" value={summary.total_due ? `${Math.round((summary.total_collected / summary.total_due) * 100)}%` : '0%'} color="purple" /></div>
            </div>

            <div className="card mb-3">
              <div className="card-body">
                <div className="row g-2">
                  <div className="col-md-6"><SearchBar onSearch={setSearch} placeholder="Search by receipt no., student name..." /></div>
                  <div className="col-md-3">
                    <select className="form-select" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                      <option value="">All Status</option>
                      <option value="pending">Pending</option>
                      <option value="paid">Paid</option>
                      <option value="partial">Partial</option>
                      <option value="waived">Waived</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <button className="btn btn-outline-secondary w-100" onClick={() => { setSearch(''); setStatusFilter(''); }}>🔄 Reset</button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header"><span>💳 Fee Collections ({count} total)</span></div>
              <DataTable columns={columns} data={collections} loading={loading} />
              <div className="card-body pt-0">
                <Pagination count={count} page={page} pageSize={15} onChange={setPage} />
              </div>
            </div>
          </div>
        )}

        {view === 'FeesSettings' && (          
              <FeeSettings/>          
        )}
      
        {view === 'FeesType' && (
          <FeeType/>
        )}
      
        {view === 'FeesStrucutre' && (
          <FeesStrucutre/>
        )}
      
        {/* {view === 'FeesDiscounts' && (
         <FeeDiscount/>
        )} */}
      
        {view === 'UpdateStudentFee' && (
          <UpdateStudentFee/>
        )}
      
        {view === 'CollectFee' && (
          <CollectFee/>
        )}
      
        {/* {view === 'Reports' && (
          <div className="card">
            <div className="card-body">
              Reports
            </div>
          </div>
        )} */}


        {/* {view !== 'list' && (
          <div className="card"><div className="card-body">
            <div className="empty-state">
              <div className="empty-icon">{view === 'discipline' ? '⚠️' : view === 'promotions' ? '⬆️' : '🔄'}</div>
              <h5>{view.charAt(0).toUpperCase() + view.slice(1)} Management</h5>
              <p>Manage student {view} records here.</p>
            </div>
          </div></div>
        )} */}
      </div>
    </>
  );
};

export default FeeManagement;
